// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XaRp","title":"styles_title__3drbx"};